<template>
<div>
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="ml-auto">
            <form  class="form-inline my-2 my-lg-0">
                <multiselect
                        v-model="search.employee"
                        class="form-control border-0 mr-2"
                        :options="employeeAll"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="เลือกพนักงาน"
                        :customLabel="employeeLabel"
                        track-by="id">
                </multiselect>
                <date-picker v-model="search.date"
                             class="mr-2"
                             placeholder="วันที่"
                             :format="changeFormat"
                             :lang="lang" confirm>
                </date-picker>
                <b-form-select
                    :options="optionActive"
                    v-model="search.active">
                </b-form-select>
                <button class="btn btn-success my-2 my-sm-0 mr-2"
                        @click="searchOtTime"
                        type="button">
                    <icon name="search"></icon> ค้นหา
                </button>
                <button class="btn btn-info my-2 my-sm-0" type="button" @click="createData">
                    <icon name="plus"></icon>
                    เพิ่มชม.OT พนักงาน
                </button>
            </form>
        </div>
    </nav>
    <div class="col-12 table-responsive">
        <table style="text-align: center" class="table table-bordered">
            <thead>
            <tr>
                <th scope="col">วันที่</th>
                <th scope="col">รหัสพนักงาน</th>
                <th scope="col">ชื่อพนักงาน</th>
                <th scope="col">ชม.OT เพิ่มเติม</th>
                <th scope="col">แก้ไข</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in data_table">
                <td>{{data.date | moment('DD/MM/YYYY')}}</td>
                <td>{{data.employee ? data.employee.employee_no : ''}}</td>
                <td>{{data.employee ? data.employee.name : ''}}</td>
                <td>{{data.hour}} ชม.</td>
                <td>
                    <a @click="getDataById(data.id)">
                        <icon name="pencil-alt"></icon>
                    </a>&nbsp;&nbsp;
                    <a @click="showDeleteModal(data.id)">
                        <icon name="trash"></icon>
                    </a>&nbsp;&nbsp;
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div v-if="data_table.length > 0">
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getDataTable(dataPaginate.current_page)">
        </vue-pagination>
    </div>
    <br>
    <b-modal hide-header hide-footer ref="loading">
        <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">
        </loading>
    </b-modal>
    <b-modal hide-footer hide-header ref="add_hour">
        <add-ot-employee-modal @submit="saveData">
        </add-ot-employee-modal>
    </b-modal>
    <b-modal hide-header hide-footer
             ref="delete_data">
        <div style="text-align: center;">
            <delete-confirm-modal @submit="deleteOT">
            </delete-confirm-modal>
        </div>
    </b-modal>
</div>
</template>

<script>
    import AddOtEmployeeModal from "./Modal/AddOTEmployeeModal";
    import {mapState} from "vuex";
    import VuePagination from "../../components/Pagination";
    import Loading from "../../components/Utility/Loading";
    import Multiselect from "vue-multiselect"
    import DatePicker from 'vue2-datepicker';
    import moment from "moment";
    import DeleteConfirmModal from "../../components/Utility/DeleteConfirmModal";

    export default {
        name: "ImportOtHour",
        components: {Loading, VuePagination, AddOtEmployeeModal,Multiselect,DatePicker,DeleteConfirmModal},
        data(){
          return{
              data_table : [],
              msg : 'กรุณารอสักครู่',
              status_loading :1,
              employeeAll : [],
              delete_id : '',
              search : {
                  date : '',
                  employee : '',
                  active:''
              },
              dataPaginate:{
                  current_page :1,
                  from : 1,
                  last_page : 1,
                  per_page : 1,
                  total : 1,
                  to : 1
              },
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      return date ? moment(date).format('DD/MM/'+year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
              optionActive : [
                  {text:"เลือกสถานะ",value:""},
                  {text:'พนักงาน',value:1},
                  {text:'ลาออก',value:2},
              ],
          }
        },
        created() {
            this.getDataTable(1);
            this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                this.employeeAll = res;
            });
        },
        methods:{
            showDeleteModal(id){
                this.delete_id = id;
                this.$refs.delete_data.show();
            },
            hideDeleteModal(){
                this.$refs.delete_data.hide();
            },
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            searchOtTime(){
                this.getDataTable(1);
            },
            showAddOTModal(){
                this.$refs.add_hour.show();
            },
            hideAddOTModal(){
                this.$refs.add_hour.hide();
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            getDataById(id){
                this.$store.dispatch("ScanEmployee/showImportHour",id).then(()=>{
                    this.showAddOTModal();
                })
            },
            deleteOT(){
                this.$store.dispatch("ScanEmployee/deleteImportHour",this.delete_id).then(()=>{
                    this.hideDeleteModal();
                    this.getDataTable(1);
                })
            },
            createData(){
                this.$router.push('import-ot-form');
                // this.$store.dispatch("ScanEmployee/clearFormData").then(()=>{
                //     this.showAddOTModal();
                // })
            },
            getDataTable(page){
                let data = {
                    page,
                    date : this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : '',
                    employee_id : this.search.employee ? this.search.employee.id : '',
                    active:this.search.active,
                };
                this.$store.dispatch("ScanEmployee/getImportHour",data).then(res=>{
                    this.data_table = res.data;
                    this.dataPaginate = {
                        current_page : res.current_page,
                        from : res.form,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.total
                    }
                })
            },
            saveData(value){
                if(value){
                    let form = {
                        id : value.id,
                        date : value.date,
                        employee_id : value.employee_id,
                        hour : value.hour,
                    }
                    this.msg = "กรุณารอสักครู่";
                    this.status_loading = 1;
                    this.showLoadingModal();
                    if(value.id){ //update
                        this.$store.dispatch("ScanEmployee/updateImportHour", {
                            id : value.id,
                            data : form,
                        }).then(()=>{
                            this.getDataTable(this.dataPaginate.current_page);
                            this.hideLoadingModal();
                        }).catch(()=>{
                            this.msg = "บันทึกข้อมูลไม่สำเร็จ";
                            this.status_loading = 3;
                            this.showLoadingModal();
                        })
                    }else{ //create
                        this.$store.dispatch("ScanEmployee/createImportHour",form).then(()=>{
                            this.getDataTable(1);
                            this.hideLoadingModal();
                        }).catch(()=>{
                            this.msg = "บันทึกข้อมูลไม่สำเร็จ";
                            this.status_loading = 3;
                            this.showLoadingModal();
                        })
                    }
                }
                this.hideAddOTModal();
            },
        },
    }
</script>

<style scoped>

</style>
